import { useRef, useSyncExternalStore } from "react";
import { createHistory } from "./commandHistory";

/** One command history for the component's lifetime, plus a re-rendering view of its state. */
export function useCommandHistory(options) {
  const ref = useRef(null);
  if (!ref.current) ref.current = createHistory(options);
  const history = ref.current;
  const view = useSyncExternalStore(history.subscribe, history.getSnapshot, history.getSnapshot);
  return [history, view];
}
